module.exports = __webpack_public_path__ + "static/media/CyBoRg.b6f4de60.jpg";